// getUserInfo
import GetUserInfo from './index.vue'

export default {
	install (Vue, options = {}) {
		const VueGetUserInfo = Vue.extend(GetUserInfo)
		let getUserInfo = null

		function $getUserInfo(type = 'buy', showClose = false) {
			if (!getUserInfo) {
				getUserInfo = new VueGetUserInfo();

				getUserInfo.$mount();

				document.querySelector(options.container || 'body').appendChild(getUserInfo.$el);
			}

			return getUserInfo.showPopup(type, showClose);
		}

		Vue.prototype.$getUserInfo = $getUserInfo;
	}
}